export enum ModalSelect {
  OpenAccount = 'AbraSuaConta',
}
